/**
 * GrowingIO 埋点工具函数
 */
import gdp from 'gio-webjs-sdk/gdp-full'

/**
 * 设置 GrowingIO 全局通用属性
 * @param {Object} props - 要设置的属性对象
 */
export function setGeneralProps(props) {
  if (!props || typeof props !== 'object') {
    console.warn('[Tracker] setGeneralProps: props must be an object')
    return
  }
  gdp('setGeneralProps', props)
}

/**
 * 设置 GrowingIO 登录用户 ID
 * @param {string | number} userId - 用户 ID
 * @param {string | number} [userKey] - 用户 Key（可选）
 * @param {Function} [callback] - 回调函数（可选）
 */
export function setGioUserId(userId, userKey, callback) {
  if (!userId) {
    console.warn('[Tracker] Cannot set user ID: userId is required')
    return
  }
  gdp('setUserId', userId, userKey, callback)
}

/**
 * 清除 GrowingIO 登录用户 ID
 * @param {Function} [callback] - 回调函数（可选）
 */
export function clearGioUserId(callback) {
  gdp('clearUserId', callback)
}

/**
 * 上报埋点事件
 * @param {string} eventName - 事件名称
 * @param {Object} [attributes] - 事件属性（可选）
 * @param {Function} [callback] - 回调函数（可选）
 */
export function track(eventName, attributes, callback) {
  if (!eventName) {
    console.warn('[Tracker] track: eventName is required')
    return
  }
  gdp('track', eventName, attributes, callback)
}
